"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _store = require("../store");
var _components = require("./components");
var _propTypes = _interopRequireDefault(require("prop-types"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var AppReact = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(AppReact, _React$Component);
  var _super = _createSuper(AppReact);
  function AppReact() {
    (0, _classCallCheck2.default)(this, AppReact);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(AppReact, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
        document = _this$props.document,
        siteInfo = _this$props.siteInfo;
      var navigationToNextPage = document.navigationToNextPage,
        redirectURLFamily = document.redirectURLFamily,
        error = document.error,
        reloadPage = document.reloadPage;
      var basePath = siteInfo.basePath,
        realm = siteInfo.realm,
        isSourceAspen = siteInfo.isSourceAspen,
        isSourceClearChoice = siteInfo.isSourceClearChoice,
        postParentResponse = siteInfo.postParentResponse;
      if (reloadPage) {
        window.location.reload();
        return;
      }
      if (navigationToNextPage) {
        if (isSourceAspen || isSourceClearChoice) {
          var response = {
            appState: 'Esigned',
            error: !!error
          };
          postParentResponse(response);
          return;
        }
        if (realm === 'LCYTS' || realm === 'LCK12' || realm === 'LCPS') {
          // YTS or K12 or LCPS
          window.location.href = "".concat(basePath).concat(redirectURLFamily);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var document = this.props.document;
      var _this$props$siteInfo = this.props.siteInfo,
        isSourceAspen = _this$props$siteInfo.isSourceAspen,
        isSourceClearChoice = _this$props$siteInfo.isSourceClearChoice;
      var submissionInProgress = document.submissionInProgress;
      var shouldHideHeaderAndFooter = isSourceAspen || isSourceClearChoice;
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "esign-agreement"
      }, /*#__PURE__*/_react.default.createElement(_components.Spinner, {
        showSpinner: submissionInProgress
      }), !shouldHideHeaderAndFooter && /*#__PURE__*/_react.default.createElement(_components.Header, null), /*#__PURE__*/_react.default.createElement("div", {
        id: "esign-body"
      }, /*#__PURE__*/_react.default.createElement(_components.DocumentCanvasScrollable, null), /*#__PURE__*/_react.default.createElement(_components.Terms, null), isSourceAspen && /*#__PURE__*/_react.default.createElement(_components.ImportantNotice, null)), !shouldHideHeaderAndFooter && /*#__PURE__*/_react.default.createElement(_components.Footer, null));
    }
  }]);
  return AppReact;
}(_react.default.Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    siteInfo: state.siteInfo,
    document: state.document
  };
};
AppReact.propTypes = {
  siteInfo: _propTypes.default.object.isRequired,
  document: _propTypes.default.shape({
    navigationToNextPage: _propTypes.default.bool,
    redirectURLFamily: _propTypes.default.string,
    INSTRUCTIONS: _propTypes.default.string,
    error: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
    bankCode: _propTypes.default.string,
    disclosureCopy: _propTypes.default.object,
    esignAgreementChecked: _propTypes.default.bool,
    applicationTermsAgreementChecked: _propTypes.default.bool,
    loanAgreementChecked: _propTypes.default.bool,
    isDocumentViewed: _propTypes.default.bool,
    submissionInProgress: _propTypes.default.bool,
    reloadPage: _propTypes.default.bool,
    offerId: _propTypes.default.string
  })
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_objectSpread({}, _store.actions), dispatch);
};
var App = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AppReact);
exports.App = App;
